import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/identification_easy_img_01.svg")